import React from 'react';
import { Badge } from 'react-bootstrap';

const VARIANTS = {
  active: 'success',
  inactive: 'secondary',
  pending: 'warning',
  suspended: 'dark',
  failed: 'danger',
  warning: 'warning',
  success: 'success',
  trial: 'info',
  at_risk: 'warning',
  critical: 'danger',
  high: 'danger',
  medium: 'warning',
  low: 'info',
  info: 'info',
  acknowledged: 'secondary',
  open: 'primary',
  muted: 'secondary',
};

export default function StatusBadge({ status, className = '' }) {
  const raw = (status || 'unknown').toString();
  const key = raw.toLowerCase();
  const variant = VARIANTS[key] || 'secondary';
  const label = raw.replace(/_/g, ' ');
  return (
    <Badge bg={variant} className={`text-capitalize ${className}`.trim()}>
      {label}
    </Badge>
  );
}
